<template>
  <div v-role="'func'">
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <v-card max-width="1000" style="margin:auto;margin-top:20px;">
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title>
              <v-row>
                 <v-col md="11">
                  <span> Histório de Pagamentos do Estudante </span>
                 </v-col>
                 <span md="1">
                  <v-btn fab small color="primary" @click="imprimirHistorico()"><v-icon>print</v-icon></v-btn>
                 </span>
              </v-row>
            </v-card-title>
            <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading"
              v-show="isLoading"></v-progress-linear>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>

                <v-row>

                  <v-col class="d-flex" cols="12" sm="6" md="6">

                    <v-autocomplete v-model="editedItem.estudante" :items="estudantes" :loading="isLoading_"
                      :rules="ruleRequired" :search-input.sync="search" color="primary" item-text="nome"
                      item-value="nome" label="Pesquise pelo nome, número de Matrícula ou Bi do estudante"
                      placeholder="Digite o nome do estudante" prepend-icon="search" return-object
                      @change="SelecionaEstudante()"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-card max-width="1000" style="margin:auto;">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Informações Pessoais e académicas
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6" md="8">
                          <span style="font-weight:bold;font-size:15px;">Nome:</span>
                          <v-chip color="#006699"
                            style="color:white;">{{(estudantes.length) ? estudantes[0].nome : ''}}</v-chip>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <span style="font-weight:bold;">Nº Matrícula:</span>
                          <span>{{(estudantes.length) ? estudantes[0].numero_matricula : ''}}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span style="font-weight:bold;">Curso:</span>
                          <span>{{(estudantes.length) ? estudantes[0].curso_descricao : ''}}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span style="font-weight:bold;">Anoacadémico:</span>
                          <span>{{(estudantes.length) ? estudantes[0].idAno_Academico+'º ano' : ''}}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span style="font-weight:bold;">Telefone:</span>
                          <span>{{(estudantes.length) ? estudantes[0].telefone : ''}}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span style="font-weight:bold;">Turma:</span>
                          <span>{{(estudantes.length) ? estudantes[0].turma_descricao : ''}}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  Informações Financeiras
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template>
                    <v-card>
                      <v-card-title>
                        <v-row>
                          <v-col cols="12" sm="8" md="5"></v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-text-field v-model="searchTable" append-icon="mdi-magnify" label="Pesquisa" single-line
                              hide-details></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-data-table :headers="headers" :items="pagamentos" :search="searchTable">
                        <template v-slot:item.Ord="{ item }">
                          <span>{{ pagamentos.indexOf(item) + 1 }}</span>
                        </template>
                        <template v-slot:item.precoUnitario="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.precoUnitario) }}</span>
                        </template>
                        <template v-slot:item.multa="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.multa) }}</span>
                        </template>
                        <template v-slot:item.subTotal="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.subTotal) }}</span>
                        </template>
                        <template v-slot:item.status_="{ item }">
                          <span v-if="item.anulado === 1" style="color:red;">Anulado</span>
                          <span v-else style="color:green;">Activo</span>
                        </template>
                      </v-data-table>
                    </v-card>

                    <v-card>
                      <v-row>
                        <v-col cols="12" md="8"></v-col>
                        <v-col cols="12" md="2">
                          <span style="font-size:18px;font-weight:bold">Total :
                          </span><span>{{ utilitarios.IntegerToMoneyValueFatura(totalGeral) }}</span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  Informações de saldo dos estudantes
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template>
                    <v-card>
                      <v-card-title>
                        <v-row>
                          <v-col cols="12" sm="8" md="5"></v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-text-field v-model="searchTable" append-icon="mdi-magnify" label="Pesquisa" single-line
                              hide-details></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-data-table :headers="headers_saldo" :items="saldoAcumulado" :search="searchTable">
                        <template v-slot:item.entrada="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.entrada) }}</span>
                        </template>
                        <template v-slot:item.saida="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.saida) }}</span>
                        </template>
                        <template v-slot:item.data_="{ item }">
                          <span>{{ dateFormat(item.data_) }}</span>
                        </template>
                        <template v-slot:item.action="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                         <v-btn
                            fab dark x-small
                            color="#006699"
                            v-bind="attrs"
                            v-on="on"
                            @click="abrirDialog(item)"
                            >
                            <v-icon dark>list</v-icon>
                          </v-btn>
                    </template>
                    <span>Ver mais detalhes</span>
                  </v-tooltip>

                </template>
                      </v-data-table>
                    </v-card>

                    <v-card>
                      <v-row>
                        <v-col cols="12" md="7"></v-col>
                        <v-col cols="12" md="3">
                          <span style="font-size:14px;font-weight:bold">Saldo disponível :
                          </span><span>{{ utilitarios.IntegerToMoneyValueFatura(totalSaldoGeral) }}</span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </v-card>
        </v-col>
      </v-row>
      <template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="50%">
      <v-card>
        <v-card-title style="background-color:#006699;color:white;">
          <span class="text-h5">Detalhes da Factura</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
               <v-col md="12">
                <v-data-table :headers="headers_" :items="detalhesVenda">

                  <template v-slot:item.precoUnitario="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.precoUnitario) }}</span>
                        </template>
                        <template v-slot:item.subTotal="{ item }">
                          <span>{{ utilitarios.IntegerToMoneyValueFatura(item.subTotal) }}</span>
                        </template>
                </v-data-table>
                </v-col>
                <v-row>

                </v-row>
                <v-col cols="12" md="6"></v-col>
                <v-col cols="12" md="6">
                  <span style="font-weight:bold;font-size:14px;">Total entregue: </span><span>{{ utilitarios.IntegerToMoneyValueFatura(itemDetalhe.valorPago) }}</span><br>
                  <span style="font-weight:bold;font-size:14px;">Total a pagar: </span><span>{{ utilitarios.IntegerToMoneyValueFatura(itemDetalhe.valorAPagar) }}</span><br>
                  <span style="font-weight:bold;font-size:14px;">Saldo antes do movimento: </span><span>{{ utilitarios.IntegerToMoneyValueFatura(itemDetalhe.saldoAnterior) }}</span><br>
                  <span style="font-weight:bold;font-size:14px;">Saldo após movimento: </span><span>{{  utilitarios.IntegerToMoneyValueFatura(itemDetalhe.entrada) }}</span><br>
                </v-col>
                </v-row>
            </v-container>
            </v-card-text>

            <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
            </v-dialog>
            </v-row>
            </template>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import axiosPedagogico from '../../plugins/axiosFinancas'
import Swal from 'sweetalert2'
import moment from 'moment'
const ls = require('local-storage')

export default {
  data: () => ({
    dialog: false,
    saldos: [],
    detalhesVenda: [],
    itemDetalhe: { valorPago: 0, valorAPagar: 0 },
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    turmasAll: [],
    utilitarios: utilitarios,
    overlay: false,
    listaDeClassesPorLancarNotas: [],
    semestres: [{ id: 1, descricao: 'Iº Semestre' }, { id: 2, descricao: 'IIº Semestre' }],
    turmasFiltered: [],
    pesquisa_parameto: [],
    historicoAcademico: [],
    valid: true,
    jaMatriculado: '',
    searchTable: '',
    classe: '',
    detalhe: '',
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    classesFiltered: [],
    anosacademicos: [],
    pagamentos: [],
    descriptionLimit: 60,
    estudanteObjecto: null,
    entries: [],
    classes: [],
    emolumentosGrouped: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      semestre: null,
      anoacademico: null,
      classe: null,
      estudante: null
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null,
      anoacademico: null,
      semestre: null,
      estudante: null
    },
    headers: [
      { text: 'Nº', value: 'Ord' },
      { text: 'Emolumento', value: 'produto' },
      { text: 'Mês', value: 'fkMes' },
      { text: 'Qtd', value: 'qtd_venda' },
      { text: 'Valor', value: 'precoUnitario' },
      { text: 'Multa', value: 'multa' },
      { text: 'Subtotal', value: 'subTotal' },
      { text: 'Autor', value: 'nomeUsuario' },
      { text: 'Data', value: 'data_' },
      { text: 'Status', value: 'status_' }
    ],
    headers_saldo: [
      { text: 'Factura', value: 'numeroDocumento' },
      { text: 'Saldo', value: 'entrada' },
      { text: 'Saída', value: 'saida' },
      { text: 'Data', value: 'data_' },
      { text: 'Autor', value: 'autor' },
      { text: 'Opção', value: 'action' }
    ],
    headers_: [
      { text: 'Emolumento', value: 'descricaoReduzida' },
      { text: 'Quant.', value: 'qtd_venda' },
      { text: 'Mês', value: 'mes' },
      { text: 'Preço Unit.', value: 'precoUnitario' },
      { text: 'Multa', value: 'multa' },
      { text: 'Valor Pago', value: 'subTotal' }
    ],
    ruleRequired: [value => value || 'campo obrigatorio']
  }),

  computed: {

    anolectivo () {
      return ls.get('anolectivo')
    },

    totalGeral () {
      let total = 0
      this.pagamentos.forEach(element => {
        total += element.subTotal
      })
      return total
    },

    totalSaldoGeral () {
      let total = 0
      total = this.saldos.length ? (this.saldos[this.saldos.length - 1].entrada) : 0
      return total
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    saldoAcumulado () {
      let soma = 0
      let saldoAnterior = 0
      let fkVendaAnterior = 0
      this.saldos.forEach(element => {
        if ((parseInt(element.fkVenda) !== fkVendaAnterior)) {
          element.saldoAnterior = soma
          saldoAnterior = soma
        } else {
          element.saldoAnterior = saldoAnterior
        }
        fkVendaAnterior = parseInt(element.fkVenda)
        soma += element.entrada + element.saida
        element.entrada = soma
      })
      return this.saldos
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      if (val.length > 1) {
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        return this.PesquisarPedGlobal(val)
      }
    }

  },

  methods: {
    dateFormat (date) {
      const formattedDate = moment(date).format('DD/MM/YYYY')
      return (formattedDate)
    },
    async abrirDialog (item) {
      try {
        this.itemDetalhe = item
        this.detalhesVenda = await axios
          .get('/itemsFactura/' + item.fkVenda)
          .then(res => res.data)
        this.dialog = true
      } catch (error) {

      }
    },
    async ConfirmarMatricula () {
      if (this.$refs.form.validate()) {

      }
    },

    async SelecionaEstudante () {
      let infoEstudante = await this.ObterDadosLocalEstudante(this.editedItem.estudante)
      if (infoEstudante.length) {
        try {
          this.overlay = true
          this.pagamentos = await this.ObterPagamentosEstudante(infoEstudante[0])
          this.emolumentosGrouped = await this.ObterPagamentosEstudanteGroupByEmolumento(infoEstudante[0])
          // Obter Saldo do estudante
         // this.saldos = await this.ObterSaldoEstudante(infoEstudante[0])
          this.overlay = false
        } catch (error) {
          console.log(error);
          this.overlay = false
        }
      } else {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar obter os dados do estudante.', 'info')
      }
    },
    async ObterSaldoEstudante (item) {
      try {
        return await axios.get('/getHistoricoSaldoEstudante/' + item.pk_estudante).then((res) => res.data)
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', '<p>Ocorreu um erro ao tentar carregar os pagamentos, por favor, tente novamente.</p>', 'error')
      }
    },

    async ObterPagamentosEstudante (params) {
      try {
        return await axios.post('/pagamentosByEstudanteById', params).then((res) => res.data)
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', '<p>Ocorreu um erro ao tentar carregar os pagamentos, por favor, tente novamente.</p>', 'error')
      }
    },

    async ObterPagamentosEstudanteGroupByEmolumento (params) {
      try {
        return await axios.post('/pagamentosByEstudanteGroupByEmolumento', params).then((res) => res.data)
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', '<p>Ocorreu um erro ao tentar carregar os pagamentos, por favor, tente novamente.</p>', 'error')
      }
    },

    async PesquisarPedGlobal (searchDB) {
      if (searchDB) {
        var payload = '{ "find" : "' + searchDB + '" }'
      } else {
        payload = '{ "find":"all" }'
      }
      try {
        this.isLoading = true
        this.estudantes = await axiosPedagogico.get('/PesquisaEstudanteGlobal/' + payload).then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false;
        Swal.fire('Informação', '<p>Ocorreu um erro durante a pesquisa do estudante!</p>', 'warning')
      }
    },
    async ObterDadosLocalEstudante (params) {
      try {
        return await axios.post('/ObterDadosEstudanteLocal', { info: params }).then((res) => res.data)
      } catch (error) {
        Swal.fire('Informação', '<p>Ocorreu um erro ao tentar obter os dados do estudante.</p>', 'warning')
      }
    },

    async ObterHistoricoAcademico (params) {
      try {
        return await axiosPedagogico.post('/ObterInscricaoTurmaEstudante', params)
      } catch (error) {
        Swal.fire('Informação', '<p>Ocorreu um erro ao tentar efectuar a operação.</p>', 'warning')
      }
    },

    ListarEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },

    async save () {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        let params =
        {
          autor: ls.get('nomeUsuario'),
          turma_id: this.editedItem.Turma.id,
          turmaDescricao: this.editedItem.Turma.turmadescricao,
          curso: this.editedItem.Turma.descricao,
          classe: this.editedItem.classe.descricao,
          estudante_id: this.editedItem.objecto.pk_estudante

        }
        try {
          let msg = await axios
            .post('/confirmarMatricula-Fin', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            this.progresso = false
            utilitarios.showAlertMessage('success', 'Confirmação efectuada com sucesso')
            this.Limpar()
          } else {
            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
          }
        } catch (error) {
          this.progresso = false
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        }
      }
    },

    Limpar () {
      this.editedItem.objecto = null
      this.editedItem.Turma = null
      this.editedItem.classe = null
    },

    async initializeturmasAll () {
      try {
        // this.isLoading = true
        this.turmasAll = await axios
          .get('/turmasFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaFindWithEstudanteCount () {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },

    async verificaSeJaConfirmado () {
      try {
        return await axios
          .post('/Estudante-ja-Confirmado', this.editedItem.objecto)
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios.get('/anoacademicoFindAll').then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally { this.isLoading = false }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesFiltered = this.classes.filter(c => c.nivel === this.editedItem.objecto.nivel_ensino)
      let result = await this.verificaSeJaConfirmado().then()
      if (result.qtd <= 0) {
        this.disabled = false
      } else { // Já tem a matrícula ou confirmação feita neste anolectivo
        // this.disabled = true
        this.$store.dispatch('textMessage', { msg: 'Estudante já confirmado no anolectivo actual', classMessage: 'msgError', timeout: 8000 })
      }
    },

    loadTurmaClasse () {
      this.turmasFiltered = this.turmasAll.filter(t => t.curso_id === this.editedItem.objecto.idCurso && t.classe_id === this.editedItem.classe.pkAnoacademico)
    },

    async imprimirHistorico () {

      try {
        this.overlay = true;
        ls.set('historicoEstudante', { dadosAcademicos: this.estudantes[0], pagamentos: this.pagamentos })
        ls.set('elumentosGrouped', this.emolumentosGrouped)
        
        /*
          Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
          uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
          temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
          escola sem interferir na página atual.
        */
       
        import('./historicoPagamento-pdf.vue').then((module) => {
          const SegundaPagina = module.default;
          const tempInstance = new Vue({
            render: (h) => h(SegundaPagina),
          });
          tempInstance.$mount();
        })
      } catch (error) {
        
      } finally {
        this.overlay = false;
      }
    }
  }
}
</script>
